import {FontSizePicker,} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { VayuBlocksDeviceControl,VayuBlocksDevice  } from '@vayu-blocks/device-control';
import { useState } from '@wordpress/element';

const defaultSize= [
    { name: 'Small', size: '30px', slug: 'small' },
    { name: 'Medium', size: '50px', slug: 'medium' },
    { name: 'Large', size: '80px', slug: 'large' },
    { name: 'Extra Large', size: '120px', slug: 'extra-large' }
]

export const VayuBlocksSize = ({label = 'Font Size', size, onChange, vayu_blocks_sizes = defaultSize}) =>{

    const device = VayuBlocksDevice(); 

    const [firstDesktop, setFirstDesktop] = useState(false);
    const [firstTablet, setFirstTablet] = useState(false);

    const value = size?.value?.[device];

    const handleSizeChange = (newVal) => {
        const currentValues = size?.value || {};
        const updatedAttributes = {
            ...currentValues,
            [device]: newVal,
        };

        const isFirstRun = !currentValues?.[device];
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        if (device === 'Desktop') {
            if (isFirstRun || firstDesktop) {
                updatedAttributes['Tablet'] = newVal;
                updatedAttributes['Mobile'] = newVal;
                localStorage.setItem('firstTablet', 'true');
                setFirstTablet(true);
                setFirstDesktop(true);
            }
        } else if (device === 'Tablet') {
            if (isTabletFirstRun) {
                updatedAttributes['Mobile'] = newVal;
                localStorage.removeItem('firstTablet');
                setFirstTablet(true);
                setFirstDesktop(false);
            }
        } else {
            setFirstTablet(false);
            setFirstDesktop(false);
        }

        onChange(size?.key, updatedAttributes);
    }

    return (
        <div className="vayu-blocks-font-size">
            <div className='vayu-blocks-font-size-label'>
                <VayuBlocksDeviceControl/> 
                <label>{ __(label, 'vayu-blocks')}</label>
            </div>

            <FontSizePicker
                fontSizes={vayu_blocks_sizes}
                onChange={handleSizeChange}
                value={value}
                __next40pxDefaultSize={true}
                withReset
                withSlider
            />
        </div>
    );
}
